import Checkbox from 'material-ui/Checkbox/Checkbox';
import LabelCheckbox from './LabelCheckbox';

export { LabelCheckbox };
export default Checkbox;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Checkbox/index.ts